import { cn } from "../../lib/cn";

export type ButtonVariant = "primary" | "ghost" | "sec" | "quiet";
export type ButtonSize = "md" | "sm";

const baseClassName =
	"press inline-flex items-center gap-1.5 font-medium font-sans cursor-pointer transition-all duration-[120ms] rounded-btn disabled:opacity-40 disabled:cursor-default [&_svg]:w-3 [&_svg]:h-3 [&_svg]:stroke-[2] [&_svg]:fill-none";

const variantClassNames: Record<ButtonVariant, string> = {
	// bright teal fill + ring + glow — exactly one of these per screen
	primary: "bg-tint text-tint-ink shadow-cta hover:opacity-[.88]",
	// translucent white on the warm ground; the app's real workhorse
	ghost: "bg-surface/50 text-ink-2 border border-line-2 backdrop-blur-[4px] hover:bg-surface/75 hover:text-ink",
	// filled neutral
	sec: "bg-surface-2 text-ink-2 border border-line hover:bg-line hover:text-ink",
	// small inline "bridge" action inside dense rows
	quiet: "bg-accent-soft text-accent border border-accent-mid hover:bg-accent-mid",
};

const sizeClassNames: Record<ButtonSize, string> = {
	md: "text-ctl-lg px-4 py-[9px]",
	sm: "text-tiny px-[9px] py-[3px] rounded-[5px]",
};

export interface ButtonStyle {
	readonly variant?: ButtonVariant;
	readonly size?: ButtonSize;
}

/**
 * A Button's classes. Button uses them, and so does a router Link that goes somewhere but should look like a button. A
 * file of its own, because a component file may only export components.
 */
export function buttonClassName({ variant = "ghost", size = "md" }: ButtonStyle = {}, className?: string): string {
	return cn(baseClassName, variantClassNames[variant], sizeClassNames[size], className);
}
